module.exports = __webpack_public_path__ + "img/4wd.8c18eed8.png";